import axios from "axios";
let refreshPending;
export function attachSessionRefresh(client) {
  client.interceptors.response.use(response => response, async error => {
    const config = error.config;
    if (error.response?.status !== 401 || !config || config._sessionRetried || /auth\/(login|register|refresh|logout)/.test(config.url || "")) throw error;
    config._sessionRetried = true;
    if (!refreshPending) refreshPending = axios.post(`${(process.env.REACT_APP_BACKEND_URL || "")}/api/auth/refresh`, {}, {withCredentials: true}).finally(() => { refreshPending = null; });
    await refreshPending;
    return client(config);
  });
}
